import React, { useState, useEffect  } from "react";
import Step1 from "../../Containers/Step1/Step1";
import Step2 from "../../Containers/Step2/Step2";
import Step3 from "../../Containers/Step3/Step3";
import Confirmation from "../../Containers/Confirmation/Confirmation";
import Success from "../../Containers/Success/Success";
import FundingUnavailable from "../../Containers/FundingUnavailable/FundingUnavailable";
import ProgressBar from "../../Components/ProgressBar/ProgressBar";
import { submitExchangeForm } from "../../services/exchangeFormApi";
import styles from "./Form.module.css";
import { useNavigate } from "react-router-dom";

const STORAGE_KEY = "ogxFormState";
const TOTAL_STEPS = 3;

function FormPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        const parsed = JSON.parse(saved);
        setFormData(parsed.formData || {});
        setStep(parsed.step || 1);
      }
    } catch {
      
    }
  }, []);

  useEffect(() => {
    const { cv, ...serializable } = formData;
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ step, formData: serializable }));
  }, [step, formData]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [step]);

  const updateData = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const goToStep = (targetStep) => setStep(targetStep);
  const nextStep = () => setStep((s) => Math.min(s + 1, TOTAL_STEPS + 1));
  const prevStep = () => setStep((s) => Math.max(s - 1, 1));

  const handleFundingUnavailable = async () => {
    setIsSubmitting(true);
    setSubmitError(null);
    try {
      await submitExchangeForm(formData);
      localStorage.removeItem(STORAGE_KEY);
      setStep(TOTAL_STEPS + 3);
    } catch (err) {
      setSubmitError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

   const handleSubmit = async () => {
    setIsSubmitting(true);
    setSubmitError(null);
    try {
      await submitExchangeForm(formData);
      localStorage.removeItem(STORAGE_KEY);
      setStep(TOTAL_STEPS + 2);
    } catch (err) {
      setSubmitError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDone = () => {
    setFormData({});
    setStep(1);
    localStorage.removeItem(STORAGE_KEY);
    navigate("/ogx");
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <Step1
            data={formData}
            updateData={updateData}
            onNext={nextStep}
            onFundingUnavailable={handleFundingUnavailable}
            isSubmitting={isSubmitting}
            submitError={submitError}
          />
        );
      case 2:
        return <Step2 data={formData} updateData={updateData} onNext={nextStep} onBack={prevStep} />;
      case 3:
        return <Step3 data={formData} updateData={updateData} onNext={nextStep} onBack={prevStep} />;
      case 4:
        return (
          <Confirmation
            data={formData}
            onEdit={goToStep}
            onSubmit={handleSubmit}
            onBack={prevStep}
            isSubmitting={isSubmitting}
            submitError={submitError}
          />
        );
      case 5:
        return <Success onDone={handleDone} />;
      case 6:
        return <FundingUnavailable onDone={handleDone} />;
      default:
        return null;
    }
  };

  return (
   <div className={styles.page}>
    <div className={styles.wrapper}>
      {renderStep()}
    </div>
  </div>
  );
}

export default FormPage;